var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 0.5C10.4898 0.514426 11.393 0.890697 11.4014 0.907227C12.8654 1.52151 15.6897 3.37561 16.9941 4.69727L17.373 5.09375C17.4722 5.20121 17.5841 5.32856 17.6533 5.42773C17.8846 5.73393 18 6.1133 18 6.49219C18 6.91504 17.8703 7.30829 17.625 7.62988L17.2354 8.05078L17.1484 8.14062C15.9648 9.4239 12.8735 11.5219 11.2568 12.1641L11.0127 12.2578C10.7191 12.363 10.308 12.4883 10.0586 12.5C9.7412 12.5 9.43748 12.4266 9.14844 12.2812C8.78735 12.0775 8.49911 11.7549 8.33984 11.376C8.23862 11.1139 8.07985 10.3304 8.0791 10.3125C7.93309 9.51839 7.84908 8.26483 7.83691 6.86035L7.83496 6.50684C7.83496 5.0352 7.92096 3.69297 8.05078 2.81836L8.16504 2.27441C8.22829 1.98651 8.31079 1.65857 8.39746 1.49121C8.71484 0.878905 9.33582 0.500175 10 0.5H10.0586ZM5.20215 5.30859C5.85341 5.30859 6.38184 5.84239 6.38184 6.5C6.3816 7.15851 5.85327 7.69043 5.20215 7.69043L1.50293 8.01758C0.673053 8.0174 0.0002359 7.33795 0 6.5C0 5.66185 0.672907 4.98162 1.50293 4.98145L5.20215 5.30859Z",
    fill: "#9983FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWithdraw);
export default __webpack_public_path__ + "static/media/right-withdraw.da603c13e8afc2e4edd1ff9789070d8d.svg";
export { ForwardRef as ReactComponent };